import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import ActionButton, { IActionButtonProps } from './actionButton';

interface IFromGeneratorAction {
  id?: IActionButtonProps['id'];
  type?: IActionButtonProps['type'];
  title: string;
  className?: string;
  noValidate?: boolean;
  disabled?: boolean;
  validationPath?: string;
  disableButtonAutoPreloader?: boolean;
  showButtonPreloader?: boolean;
  onClick?: () => void;
  isHidden?: boolean | (() => boolean);
}

interface IFormGeneratorActionsProps {
  returnActionWithValidation: (cb?: IActionButtonProps['onClick'], validationPath?: string) => () => void;
  returnActionWithNoValidation: (cb?: IActionButtonProps['onClick']) => () => void;
  actions: IFromGeneratorAction[];
  disabled?: boolean;
}

export const FormGeneratorActions = ({
  returnActionWithValidation,
  returnActionWithNoValidation,
  actions,
  disabled,
}: IFormGeneratorActionsProps) => {
  const { i18n } = useTranslation();

  return (
    <ul className="form-actions">
      {!Array.isArray(actions)
        ? null
        : actions.map((action) => {
            const { isHidden } = action;
            const isActionHidden = typeof isHidden === 'function' ? isHidden() : isHidden;

            return isActionHidden ? null : (
              <li key={action.title}>
                <ActionButton
                  onClick={
                    action.noValidate
                      ? returnActionWithNoValidation(action.onClick)
                      : returnActionWithValidation(action.onClick, action.validationPath)
                  }
                  className={action.className || ''}
                  id={action.id}
                  type={action.type}
                  disabled={action.disabled || disabled || false}
                  disableButtonAutoPreloader={action.disableButtonAutoPreloader}
                  showButtonPreloader={action.showButtonPreloader}>
                  {i18n.t(action.title as KeyMapKeys)}
                </ActionButton>
              </li>
            );
          })}
    </ul>
  );
};
